import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/providers/Store';

const getEnginesState = (state: RootState) => state.engines;

export const engineSelectors = {
  getEngines: createSelector(
    getEnginesState,
    (enginesState) => enginesState.engines,
  ),

  getEnginesLoading: createSelector(
    getEnginesState,
    (enginesState) => enginesState.isLoading,
  ),

  getEngineDetail: createSelector(
    getEnginesState,
    (enginesState) => enginesState.engineDetail.data,
  ),

  getEngineDetailLoading: createSelector(
    getEnginesState,
    (enginesState) => enginesState.engineDetail.isLoading,
  ),
};
